import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SharedService } from '../shared.service';

@Component({
    selector: 'ashcorp-loader',
    styleUrls: ['./loader.component.scss'],
    templateUrl: './loader.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AshcorpLoaderComponent implements AfterViewInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    /** When true, show spinner whenever this component is mounted (page-local loading). */
    @Input() active = false;
    globalLoading = false;

    constructor(
        private _sharedService: SharedService,
        private _cdr: ChangeDetectorRef
    ) {
    }

    get visible(): boolean {
        return this.active || this.globalLoading;
    }

    ngAfterViewInit() {
        this._sharedService.loader$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((loading) => {
                this.globalLoading = loading;
                this._cdr.detectChanges();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
